import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../auth/auth-guard.service";
import { TracksListComponent } from "./tracks-list/tracks-list.component";
import { ClientPanelComponent } from "./client-panel/client-panel.component";

const appRoutes: Routes = [
    // { path: 'my-tracks', component: MyTracksComponent, canActivate: [AuthGuard], data: { userRole: ['customer'] } },
    {
        path: 'my-tracks',
        component: ClientPanelComponent,
        canActivate: [AuthGuard],
        data: { userRole: ['customer'] },
        children:
            [
                { path: '', component: TracksListComponent, canActivate: [AuthGuard], data: { userRole: ['customer'] } }
            ],
    }
]

@NgModule({
    imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
    exports: [RouterModule]
})
export class ClientPanelRoutingModule { };